var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoFlechaDownVioleta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.27 14.49",
    style: {
      enableBackground: "new 0 0 25.27 14.49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.downArrowViolet{fill:#7367F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down_00000041991702369481656980000016224302343911045031_",
    className: "downArrowViolet",
    d: "M12.64,10.11l9.53-9.54 c0.7-0.7,1.83-0.71,2.54-0.01c0,0,0.01,0.01,0.01,0.01c0.7,0.71,0.7,1.84,0,2.55l-10.8,10.81c-0.68,0.68-1.78,0.7-2.49,0.05 L0.56,3.13c-0.7-0.7-0.71-1.84,0-2.55c0.7-0.7,1.84-0.71,2.55,0l0,0L12.64,10.11z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFlechaDownVioleta);
export default __webpack_public_path__ + "static/media/icono-flecha-down-violeta.026f3f1b93310158125dabc900749722.svg";
export { ForwardRef as ReactComponent };